import { get, isArray, isString, isPlainObject, fromPairs, isNil } from 'lodash';
import { isCountryCz } from './CroUtils';

export const convert = (data, transform = {}) => {
  const arrays = Object.keys(transform)
    .filter(key => isPlainObject(transform[key]))
    .filter(key => isArray(get(data, key, null)))
    .map(key => [key, data[key].map(row => convert(row, transform[key]))]);

  const objects = Object.keys(transform)
    .filter(key => isPlainObject(transform[key]))
    .filter(key => isPlainObject(get(data, key, null)))
    .map(key => [key, convert(data[key], transform[key])]);

  const values = Object.keys(transform)
    .filter(key => transform[key] instanceof Function)
    .filter(key => get(data, key, null) !== null)
    .map(key => [key, isArray(data[key]) ? data[key].map(row => transform[key](row)) : transform[key](data[key])]);
  return { ...data, ...fromPairs(values), ...fromPairs(arrays), ...fromPairs(objects) };
}

export const addressToForm = addr => {
  const isCz = isCountryCz(addr.country);
  if (isPlainObject(addr.municipality) && isCz) return addr;
  return { ...addr, municipality: isCz ? addr.municipalityId !== undefined ? { fullName: addr.municipality, id: addr.municipalityId, composedMunicipality: addr.municipality } : null : addr.municipality };
}

export const addressToFormStatement = addr => {
  if (isNil(addr.municipality)) return addr;
  if (isPlainObject(addr.municipality)) return addr;
  return { ...addr, municipality: { fullName: addr.municipality, id: addr.municipalityId } };
}

export const addressToSend = addr => {
  if (isNil(addr.municipality) || isString(addr.municipality)) return { ...addr, municipality: addr.municipality, municipalityId: undefined };
  return { ...addr, municipality: addr.municipality.fullName, municipalityId: addr.municipality.id };
}
